import { render } from "./NotePanel.vue?vue&type=template&id=71ee77c2&scoped=true"
import script from "./NotePanel.vue?vue&type=script&lang=js"
export * from "./NotePanel.vue?vue&type=script&lang=js"

import "./NotePanel.vue?vue&type=style&index=0&id=71ee77c2&scoped=true&lang=css"

import exportComponent from "/home/magpie/dnd/client/gamemasterai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ee77c2"]])

export default __exports__